import request from '../axios'

// 企业运维
// 校验邀请、新增是否可用
export const checkUserNameCanWork = data => request({
	url: 'sys/sysuser/checkUserNameCanWork',
	method: 'post',
	data: data
})

// 获取企业配置数据
export const configcompanyserviceInfo = params => request({
	url: 'config/configcompanyservice/info',
	method: 'get',
	params: params
})

// 设置企业数据的许可状态
export const configcompanyserviceSetCompanyDataPermit = data => request({
	url: 'config/configcompanyservice/setCompanyDataPermit',
	method: 'post',
	data: data,
})

// 更新修改企业数据其他内容
export const configcompanyserviceUpdateCompanySetting = data => request({
	url: 'config/configcompanyservice/updateCompanySetting',
	method: 'post',
	data: data,
})

// 获取选配区+基础区数据（功能权限）
export const syscompanyFunctionMenu = params => request({
	url: 'sys/syscompany/functionMenu',
	method: 'get',
	params: params
})

// 创建企业
export const syscompanyCreateCompany = data => request({
	url: 'sys/syscompany/createCompany',
	method: 'post',
	data: data,
})

// 获取企业基本信息
export const syscompanyDetailedInfo = params => request({
	url: 'sys/syscompany/detailedInfo',
	method: 'get',
	params: params
})

// 编辑企业
export const syscompanyDetailedInfoUpdate = data => request({
	url: 'sys/syscompany/detailedInfoUpdate',
	method: 'post',
	data: data,
})

// 企业清除数据
export const syscompanyDataClear = data => request({
	url: 'sys/syscompany/dataClear',
	method: 'post',
	data: data,
})

// 切换账号类型（切非主账号、主账号、运维账号）
export const sysuserCompanyDataChangeAccountType = data => request({
	url: 'sys/sysuser/companyDataChangeAccountType',
	method: 'post',
	data: data,
})

// 顶部数据（根据企业ID获取企业的基本信息）
export const syscompanyInfo = params => request({
	url: 'sys/syscompany/info/' + params.id,
	method: 'get'
})

// 获取企业运维账号列表
export const syscompanyServiceAccountList = params => request({
	url: 'sys/syscompany/serviceAccountList/' + params.id,
	method: 'get'
})

// 获取企业列表
export const syscompanyList = params => request({
	url: 'sys/syscompany/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 企业延期
export const syscompanyPostpone = data => request({
	url: 'sys/syscompany/postpone',
	method: 'post',
	data: data,
})

// 企业停用
export const syscompanyStop = data => request({
	url: 'sys/syscompany/stop',
	method: 'post',
	data: data,
})

// 获取成员列表
export const sysuserCompanyDataList = params => request({
	url: 'sys/sysuser/companyDataList',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 注销成员
export const sysuserCancelAccount = data => request({
	url: 'sys/sysuser/cancelAccount',
	method: 'post',
	data: data,
})

// 移除成员
export const sysuserRemoveAccount = data => request({
	url: 'sys/sysuser/removeAccount',
	method: 'post',
	data: data,
})

// 重置密码
export const sysuserCompanyDataResetPassword = data => request({
	url: 'sys/sysuser/companyDataResetPassword',
	method: 'post',
	data: data,
})

// 根据企业ID获取当前企业下全部的主账号
export const syscompanyGetMasterInfo = params => request({
	url: 'sys/syscompany/getMasterInfo/' + params.id,
	method: 'get'
})

// 添加成员/运维
export const sysuserAddCompanyUser = data => request({
	url: 'sys/sysuser/addCompanyUser',
	method: 'post',
	data: data,
})

// 部门--获取部门信息/移入成员弹窗--右侧组织+部门数据（从组织移动时 传不打算展示的组织ID => 不展示当前组织数据）
export const sysdepartmentListAllDepartment = params => request({
	url: 'sys/sysdepartment/listAllDepartment',
	method: 'get',
	params: params
})

// 部门--获取右侧详情信息
export const sysdepartmentDepartmentInfo = data => request({
	url: 'sys/sysdepartment/departmentInfo',
	method: 'post',
	data: data,
})

// 编辑企业功能数据
export const syscompanyUpdateCompanyActionData = data => request({
	url: 'sys/syscompany/updateCompanyActionData',
	method: 'post',
	data: data,
})

// 获取日志列表
export const syschangelogList = params => request({
	url: 'sys/syschangelog/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 日志--获取变更类型
export const syschangelogChangeTypes = params => request({
	url: 'sys/syschangelog/changeTypes',
	method: 'get',
	params: params
})

// 日志--获取变更详情
export const syschangelogDetailed = data => request({
	url: 'sys/syschangelog/detailed',
	method: 'post',
	data: data,
})

// 获取成员信息_企业运维使用
export const sysuserUsersInfoCompany = data => request({
	url: 'sys/sysuser/usersInfoCompany',
	method: 'post',
	data: data,
})

// 获取数据占比情况（遗留数据）
export const syscompanyGetDataLeave = params => request({
	url: 'sys/syscompany/getDataLeave/' + params.id,
	method: 'get',
	// params: params
})

// 清理遗留数据（会同步清理掉腾讯云的数据）
export const syscompanyClearDataLeave = data => request({
	url: 'sys/syscompany/clearDataLeave',
	method: 'post',
	data: data,
})

// 获取遗留数据的配置
export const syscompanyGetDataLeaveConfig = params => request({
	url: 'sys/syscompany/getDataLeaveConfig/' + params.id,
	method: 'get'
})

// 修改遗留数据配置信息
export const syscompanyUpdateDataLeave = data => request({
	url: 'sys/syscompany/updateDataLeave',
	method: 'post',
	data: data,
})

